import { useMemo } from 'react';
import {
  buildNeedsAttentionQueue,
  buildRegistrarStats,
  buildSessionStatusBreakdown,
} from '../utils/registrarDashboard';

const useRegistrarDashboardStats = (transcriptions) => {
  const stats = useMemo(() => buildRegistrarStats(transcriptions), [transcriptions]);
  const queues = useMemo(() => buildNeedsAttentionQueue(transcriptions), [transcriptions]);
  const statusSegments = useMemo(
    () => buildSessionStatusBreakdown(transcriptions),
    [transcriptions]
  );
  const recentSessions = useMemo(() => {
    const list = Array.isArray(transcriptions) ? transcriptions : [];
    return [...list]
      .sort(
        (a, b) =>
          new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime()
      )
      .slice(0, 5);
  }, [transcriptions]);

  return { stats, queues, statusSegments, recentSessions };
};

export default useRegistrarDashboardStats;
